<template>
  <div class="lxm-cf-project">
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->

    <div class="page">
      <!--<lxm-tabs :tabs="tabs"></lxm-tabs>-->
      <transition name="lxm-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <!--<lxm-close-notification :highlight="true"></lxm-close-notification>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-cf-project
    &>.page
      padding-top: 0
</style>

<script>
  import LxmNav from '../../common/LxmNav.vue'
  import LxmTabs from '../../common/LxmTabs.vue'
  import LxmCloseNotification from '../../common/LxmCloseNotification.vue'
  export default {
    components: {
      LxmNav,
      LxmTabs,
      LxmCloseNotification
    },
    computed: {
      tabs () {
        return [{
          name: '反馈',
          to: { path: '/main/cf/project/feedback' },
          active: this.$route.path === '/main/cf/project/feedback' || this.$route.path === '/main/cf/project'
        }, {
          name: '统计',
          to: { path: '/main/cf/project/stat' },
          active: this.$route.path === '/main/cf/project/stat'
        }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?eed21afc